import { render, staticRenderFns } from "./departmentmodal.vue?vue&type=template&id=0988a530"
import script from "./departmentmodal.vue?vue&type=script&lang=js"
export * from "./departmentmodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports